import { call, put, takeEvery } from 'typed-redux-saga'
import { OkvedsBlockApi, OkvedsNS, okvedsSlice } from 'Pages/registratorCabinet'
import { errorHandler, loadersSlice } from 'Modules'

export function* getAllOkveds() {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(OkvedsBlockApi.getAllOkvedsRbidosRequestApi)
		yield* put(okvedsSlice.actions.setAll(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* createOkvedPackage(action: OkvedsNS.createOkvedPackage) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(OkvedsBlockApi.createOkvedPackage, action.payload)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* okvedsSaga() {
	yield* takeEvery(okvedsSlice.actions.getAll.type, getAllOkveds)
	yield* takeEvery(okvedsSlice.actions.createOne.type, createOkvedPackage)
}
